/* Benjie's Beauties Boutique - theme behaviour.
   Vanilla ES2019. No third-party libraries, no external requests.
   Every module is optional: if its markup is absent, it does nothing. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- helpers */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function money(cents, format) {
    // Falls back to a plain decimal when no format string is supplied.
    var value = (cents / 100).toFixed(2);
    if (!format) return value;
    return format.replace(/\{\{\s*amount\s*\}\}/, value);
  }

  /* --------------------------------------------------- announcement rotator */
  $$('[data-bbb-announce]').forEach(function (bar) {
    var items = $$('.bbb-announce__item', bar);
    if (items.length < 2 || !bar.classList.contains('bbb-announce--rotate')) return;
    var speed = parseInt(bar.dataset.bbbSpeed, 10) || 5000;
    var i = 0;
    items.forEach(function (el, n) { el.classList.toggle('is-active', n === 0); });
    if (reduceMotion) return; // hold on the first message rather than cycling
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, speed);
  });

  /* ------------------------------------------------------- mobile nav drawer */
  var drawer = $('[data-bbb-drawer]');
  var overlay = $('[data-bbb-overlay]');
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var first = $('a, button', drawer);
    if (first) first.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  $$('[data-bbb-drawer-open]').forEach(function (b) { b.addEventListener('click', openDrawer); });
  $$('[data-bbb-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ------------------------------------------------------------- quantity ui */
  $$('[data-bbb-qty]').forEach(function (wrap) {
    var input = $('input', wrap);
    if (!input) return;
    $$('button', wrap).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.dataset.bbbQtyStep === 'down' ? -1 : 1;
        var min = parseInt(input.min, 10) || 1;
        var next = (parseInt(input.value, 10) || min) + step;
        input.value = next < min ? min : next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* -------------------------------------------------------- variant picker */
  $$('[data-bbb-product]').forEach(function (root) {
    var data = $('[data-bbb-variant-json]', root);
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }

    var radios = $$('[data-bbb-option] input[type="radio"]', root);
    if (!radios.length) return;

    var priceEl = $('[data-bbb-price]', root);
    var submit = $('[data-bbb-submit]', root);
    var idInput = $('[data-bbb-variant-id]', root);
    var format = root.dataset.bbbMoneyFormat || '';

    function chosen() {
      return $$('[data-bbb-option]', root).map(function (group) {
        var picked = $('input[type="radio"]:checked', group);
        return picked ? picked.value : null;
      });
    }

    function selected() {
      var want = chosen();
      return variants.filter(function (v) {
        return want.every(function (val, idx) { return val === null || v.options[idx] === val; });
      })[0];
    }

    function sync() {
      var v = selected();
      if (idInput && v) idInput.value = v.id;
      if (priceEl && v && typeof v.price === 'number') priceEl.textContent = money(v.price, format);
      if (submit) {
        var ok = !!(v && v.available);
        submit.disabled = !ok;
        submit.textContent = ok
          ? (submit.dataset.bbbAdd || submit.textContent)
          : (v ? (submit.dataset.bbbSoldOut || submit.textContent) : (submit.dataset.bbbUnavailable || submit.textContent));
      }
      if (v && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    radios.forEach(function (i) { i.addEventListener('change', sync); });
    sync();
  });

  /* ------------------------------------------------------------ pdp gallery */
  $$('[data-bbb-gallery]').forEach(function (gallery) {
    var main = $('[data-bbb-gallery-main] img', gallery);
    if (!main) return;
    $$('[data-bbb-thumb]', gallery).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.dataset.bbbSrc;
        var srcset = thumb.dataset.bbbSrcset;
        if (src) main.src = src;
        if (srcset) main.srcset = srcset;
        main.alt = thumb.dataset.bbbAlt || main.alt;
        $$('[data-bbb-thumb]', gallery).forEach(function (t) { t.setAttribute('aria-current', String(t === thumb)); });
      });
    });
  });

  /* ------------------------------------------- add to cart from a card/form */
  function refreshCart() {
    // Hand off to whatever cart the host theme ships. Eurus and most OS 2.0
    // themes listen for at least one of these; the last line is the fallback.
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('bbb:cart-updated', { bubbles: true }));
    var drawerEl = document.querySelector('cart-drawer, #CartDrawer, [data-cart-drawer]');
    if (drawerEl && typeof drawerEl.open === 'function') { drawerEl.open(); return true; }
    if (drawerEl && drawerEl.classList) { drawerEl.classList.add('is-open', 'active'); return true; }
    return false;
  }

  function bumpCount(qty) {
    $$('[data-bbb-cart-count]').forEach(function (el) {
      var n = (parseInt(el.textContent, 10) || 0) + qty;
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  $$('[data-bbb-add-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return; // let the browser post the form normally
      e.preventDefault();
      var btn = $('[type="submit"]', form);
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = btn.dataset.bbbAdding || original; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(Object.fromEntries(new FormData(form).entries()))
      })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'error');
          bumpCount(parseInt(res.body.quantity, 10) || 1);
          if (btn) btn.textContent = btn.dataset.bbbAdded || original;
          if (!refreshCart()) window.location.href = '/cart';
        })
        .catch(function () {
          if (btn) btn.textContent = btn.dataset.bbbError || original;
        })
        .then(function () {
          setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = original; } }, 1600);
        });
    });
  });
})();
